var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Danh sách học sinh",
            visible: _vm.dialogFormVisible,
            width: "1275px",
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c("div", { staticStyle: { "margin-bottom": "1%" } }, [
            _c("span", { staticStyle: { color: "green" } }, [
              _vm._v("✔ : Thông tin không thay đổi"),
            ]),
            _c("span", { staticStyle: { color: "red", "margin-left": "7%" } }, [
              _vm._v("✘ : Thông tin đã thay đổi"),
            ]),
          ]),
          _vm.listConfirm.length !== 0
            ? _c(
                "el-table",
                {
                  ref: "multipleTable",
                  attrs: {
                    "empty-text": _vm.textTable,
                    data: _vm.listConfirm,
                    "header-cell-style": _vm.tableHeaderColor,
                    "max-height": 400,
                    border: "",
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", align: "center", width: "55" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      fixed: "",
                      label: "STT",
                      width: "50",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "150",
                      fixed: "",
                      align: "center",
                      label: "Họ và tên",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.name))]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2020036417
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Mã học sinh",
                      width: "120",
                      align: "center",
                      prop: "name",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.kidCode))]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3897152269
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Lớp",
                      width: "120",
                      align: "center",
                      prop: "name",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.nameClass))]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3942656495
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Thông tin học sinh",
                      width: "120",
                      prop: "name",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.notifyInfo === "true"
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "green" } },
                                    [_vm._v("✔")]
                                  )
                                : _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("✘")]
                                  ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1957951966
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Thông tin khoản thu",
                      align: "center",
                      width: "120",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.notifyPayment === "true"
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "green" } },
                                    [_vm._v("✔")]
                                  )
                                : _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("✘")]
                                  ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3714471978
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Thông tin khoản thu âm",
                      align: "center",
                      width: "120",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.notifyMinusPayment === "true"
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "green" } },
                                    [_vm._v("✔")]
                                  )
                                : _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("✘")]
                                  ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2476233734
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Tiền thanh toán",
                      align: "center",
                      width: "120",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.notifyMoney === "true"
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "green" } },
                                    [_vm._v("✔")]
                                  )
                                : _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("✘")]
                                  ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3133643680
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Số liệu điểm danh",
                      align: "center",
                      width: "129",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.notifyAttendance === "true"
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "green" } },
                                    [_vm._v("✔")]
                                  )
                                : _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("✘")]
                                  ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      955894743
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Số liệu điểm danh âm",
                      align: "center",
                      width: "129",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.notifyMinusAttendance === "true"
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "green" } },
                                    [_vm._v("✔")]
                                  )
                                : _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("✘")]
                                  ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1231639707
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
          _c("br"),
          _vm.listConfirm.length !== 0
            ? _c(
                "el-row",
                { staticClass: "overwrite" },
                [
                  _c("el-col", { attrs: { span: 9 } }, [
                    _c(
                      "div",
                      [
                        _c(
                          "el-checkbox",
                          {
                            model: {
                              value: _vm.overwriteAttendance,
                              callback: function ($$v) {
                                _vm.overwriteAttendance = $$v
                              },
                              expression: "overwriteAttendance",
                            },
                          },
                          [_vm._v("Cho phép ghi đè điểm danh\n          ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c(
                      "div",
                      [
                        _c(
                          "el-checkbox",
                          {
                            model: {
                              value: _vm.overwritePayment,
                              callback: function ($$v) {
                                _vm.overwritePayment = $$v
                              },
                              expression: "overwritePayment",
                            },
                          },
                          [_vm._v("Cho phép ghi đè khoản thu\n          ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("el-col", { attrs: { span: 7 } }, [
                    _c(
                      "div",
                      [
                        _c(
                          "el-checkbox",
                          {
                            model: {
                              value: _vm.overwriteNote,
                              callback: function ($$v) {
                                _vm.overwriteNote = $$v
                              },
                              expression: "overwriteNote",
                            },
                          },
                          [_vm._v("Cho phép ghi đè ghi chú\n          ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm.listConfirm.length !== 0
            ? _c(
                "el-row",
                {
                  staticClass: "overwrite",
                  staticStyle: { "margin-top": "25px" },
                },
                [
                  _c("el-col", { attrs: { span: 9 } }, [
                    _c(
                      "div",
                      { staticClass: "checkbox-container" },
                      [
                        _c(
                          "el-checkbox",
                          {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.overwriteMoney,
                              callback: function ($$v) {
                                _vm.overwriteMoney = $$v
                              },
                              expression: "overwriteMoney",
                            },
                          },
                          [
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v("Ghi đè tiền thanh toán từ File Excel"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { color: "black" },
                          on: { change: _vm.changeCreateMoney },
                          model: {
                            value: _vm.checkCreateMoney,
                            callback: function ($$v) {
                              _vm.checkCreateMoney = $$v
                            },
                            expression: "checkCreateMoney",
                          },
                        },
                        [
                          _vm._v(
                            "Thêm mới tiền đã thu\n          (Lần đầu)\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.listConfirm.length !== 0
            ? _c(
                "el-row",
                {
                  staticClass: "overwrite",
                  staticStyle: { "margin-top": "20px" },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 9 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: { change: _vm.handleChangeCheckRegisterPackage },
                          model: {
                            value: _vm.checkRegisterPackage,
                            callback: function ($$v) {
                              _vm.checkRegisterPackage = $$v
                            },
                            expression: "checkRegisterPackage",
                          },
                        },
                        [_vm._v("\n          Đăng ký gói\n        ")]
                      ),
                      _vm.checkRegisterPackage
                        ? _c(
                            "el-row",
                            {
                              staticStyle: { "margin-top": "20px" },
                              attrs: { type: "flex", gutter: 9 },
                            },
                            [
                              _c("el-col", { attrs: { span: 16 } }, [
                                _c("span", [_vm._v("Thời gian đăng ký:")]),
                                _c(
                                  "div",
                                  { staticStyle: { "margin-top": "6px" } },
                                  [
                                    _c(
                                      "el-row",
                                      { attrs: { type: "flex" } },
                                      [
                                        _c("el-col", { attrs: { span: 11 } }, [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                width: "100%",
                                              },
                                            },
                                            [
                                              _c("el-date-picker", {
                                                class:
                                                  _vm.validPackage
                                                    .isStartDate ||
                                                  _vm.validPackage
                                                    .isCompareDates
                                                    ? "block"
                                                    : "",
                                                attrs: {
                                                  type: "date",
                                                  placeholder: "Ngày bắt đầu",
                                                  format: "dd/MM/yyyy",
                                                  "value-format": "yyyy-MM-dd",
                                                  size: "small",
                                                },
                                                model: {
                                                  value: _vm.startDate,
                                                  callback: function ($$v) {
                                                    _vm.startDate = $$v
                                                  },
                                                  expression: "startDate",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm.validPackage.isStartDate
                                            ? _c(
                                                "div",
                                                { staticClass: "message-err" },
                                                [
                                                  _c("span", {
                                                    staticClass:
                                                      "el-icon-warning",
                                                  }),
                                                  _vm._v(
                                                    "\n                    Vui lòng chọn trường này!\n                  "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]),
                                        _c(
                                          "el-col",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "center",
                                              "justify-content": "center",
                                              "max-height": "32px",
                                            },
                                            attrs: { span: "2" },
                                          },
                                          [
                                            _c("div", [
                                              _c("span", [_vm._v("-")]),
                                            ]),
                                          ]
                                        ),
                                        _c("el-col", { attrs: { span: 11 } }, [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                width: "100%",
                                              },
                                            },
                                            [
                                              _c("el-date-picker", {
                                                class:
                                                  _vm.validPackage.isEndDate ||
                                                  _vm.validPackage
                                                    .isCompareDates
                                                    ? "block"
                                                    : "",
                                                attrs: {
                                                  type: "date",
                                                  placeholder: "Ngày kết thúc",
                                                  format: "dd/MM/yyyy",
                                                  "value-format": "yyyy-MM-dd",
                                                  size: "small",
                                                  "picker-options":
                                                    _vm.pickerEndDateOptions,
                                                  disabled: !_vm.startDate,
                                                },
                                                model: {
                                                  value: _vm.endDate,
                                                  callback: function ($$v) {
                                                    _vm.endDate = $$v
                                                  },
                                                  expression: "endDate",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm.validPackage.isEndDate
                                            ? _c(
                                                "div",
                                                { staticClass: "message-err" },
                                                [
                                                  _c("span", {
                                                    staticClass:
                                                      "el-icon-warning",
                                                  }),
                                                  _vm._v(
                                                    "\n                    Vui lòng chọn trường này!\n                  "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm.validPackage.isCompareDates
                                      ? _c(
                                          "div",
                                          { staticClass: "message-err" },
                                          [
                                            _c("span", {
                                              staticClass: "el-icon-warning",
                                            }),
                                            _vm._v(
                                              "\n                Thời gian không hợp lệ\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "margin-bottom": "6px" } },
                                    [_vm._v("Chọn gói:")]
                                  ),
                                  _c("el-col", { attrs: { span: 24 } }, [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            class: _vm.validPackage
                                              .isIdListPackage
                                              ? "block"
                                              : "",
                                            attrs: {
                                              size: "small",
                                              placeholder: "Chọn gói",
                                              clearable: true,
                                            },
                                            model: {
                                              value: _vm.idPackage,
                                              callback: function ($$v) {
                                                _vm.idPackage = $$v
                                              },
                                              expression: "idPackage",
                                            },
                                          },
                                          _vm._l(
                                            _vm.packages,
                                            function (item, index) {
                                              return _c("el-option", {
                                                key: index,
                                                attrs: {
                                                  label: item.namePackage,
                                                  value: item.id,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm.validPackage.isIdListPackage
                                      ? _c(
                                          "div",
                                          { staticClass: "message-err" },
                                          [
                                            _c("span", {
                                              staticClass: "el-icon-warning",
                                            }),
                                            _vm._v(
                                              "\n                Vui lòng chọn trường này!\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { color: "black" },
                          on: { change: _vm.changeUpdateMoney },
                          model: {
                            value: _vm.checkUpdateMoney,
                            callback: function ($$v) {
                              _vm.checkUpdateMoney = $$v
                            },
                            expression: "checkUpdateMoney",
                          },
                        },
                        [_vm._v("Cập nhật tiền đã\n          thu\n        ")]
                      ),
                      _vm.updateMoney === "UPDATE_MONEY"
                        ? _c(
                            "el-row",
                            { staticStyle: { "margin-top": "15px" } },
                            [
                              _c(
                                "el-col",
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.statusTransactionEntry,
                                        callback: function ($$v) {
                                          _vm.statusTransactionEntry = $$v
                                        },
                                        expression: "statusTransactionEntry",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          staticStyle: { color: "black" },
                                          attrs: { label: "MONEY_WALLET" },
                                        },
                                        [_vm._v("Không chuyển")]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          staticStyle: { color: "black" },
                                          attrs: { label: "MONEY_MONTH" },
                                        },
                                        [_vm._v("Sang tháng sau")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("br"),
          _c("br"),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { offset: 20, span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.loadingImport },
                      on: { click: _vm.submitImport },
                    },
                    [_vm._v("Lưu")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: { click: _vm.handleClose },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-close" }),
                      _vm._v(" Đóng\n        "),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Danh sách học sinh sai thông tin",
            visible: _vm.dialogFailInformation,
            width: "1153px",
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFailInformation = $event
            },
          },
        },
        [
          _vm.listError !== 0
            ? _c(
                "el-table",
                {
                  ref: "multipleTable",
                  attrs: {
                    "empty-text": _vm.textTable,
                    data: _vm.listError,
                    "header-cell-style": _vm.tableHeaderColor,
                    border: "",
                    "max-height": 400,
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      fixed: "",
                      label: "STT",
                      width: "50",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      width: "160",
                      fixed: "",
                      align: "center",
                      label: "Họ và tên",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.name == null
                                ? _c("div", [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [_vm._v("Không tìm thấy học sinh")]
                                    ),
                                  ])
                                : _c("div", [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "cornflowerblue",
                                        },
                                      },
                                      [_vm._v(_vm._s(scope.row.name))]
                                    ),
                                    _c("br"),
                                    _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [_vm._v(_vm._s(scope.row.nameFail))]
                                    ),
                                  ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2356220792
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Mã học sinh",
                      width: "150",
                      align: "center",
                      prop: "name",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.kidCode === null
                                ? _c("div", [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [_vm._v(_vm._s(scope.row.kidCodeFail))]
                                    ),
                                  ])
                                : _c("div", [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "cornflowerblue",
                                        },
                                      },
                                      [_vm._v(_vm._s(scope.row.kidCode))]
                                    ),
                                    _c("br"),
                                    _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [_vm._v(_vm._s(scope.row.kidCodeFail))]
                                    ),
                                  ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2568560892
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Ngày sinh",
                      width: "150",
                      align: "center",
                      prop: "name",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                { staticStyle: { color: "cornflowerblue" } },
                                [_vm._v(_vm._s(scope.row.birthDay))]
                              ),
                              _c("br"),
                              _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v(_vm._s(scope.row.birthDayFail)),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2767771727
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Số điện thoại",
                      width: "150",
                      align: "center",
                      prop: "name",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                { staticStyle: { color: "cornflowerblue" } },
                                [_vm._v(_vm._s(scope.row.phoneParent))]
                              ),
                              _c("br"),
                              _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v(_vm._s(scope.row.phoneParentFail)),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1921425839
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Khối",
                      width: "150",
                      align: "center",
                      prop: "name",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                { staticStyle: { color: "cornflowerblue" } },
                                [_vm._v(_vm._s(scope.row.nameGrade))]
                              ),
                              _c("br"),
                              _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v(_vm._s(scope.row.nameGradeFail)),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      875204783
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Lớp",
                      width: "150",
                      align: "center",
                      prop: "name",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                { staticStyle: { color: "cornflowerblue" } },
                                [_vm._v(_vm._s(scope.row.nameClass))]
                              ),
                              _c("br"),
                              _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v(_vm._s(scope.row.nameClassFail)),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3138565487
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Nhóm",
                      width: "150",
                      align: "center",
                      prop: "name",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                { staticStyle: { color: "cornflowerblue" } },
                                [_vm._v(_vm._s(scope.row.nameGroup))]
                              ),
                              _c("br"),
                              _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v(_vm._s(scope.row.nameGroupFail)),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      18219247
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
          _c("div", { staticClass: "custom_button_error" }, [
            _c("div", [
              _c(
                "span",
                { staticStyle: { color: "red", "margin-right": "480px" } },
                [
                  _vm._v(
                    '* Mời bạn nhấn "Tiếp tục" để hiển thị danh sách học sinh đúng thông tin'
                  ),
                ]
              ),
            ]),
            _c(
              "div",
              [
                _vm.isContinue
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary", loading: _vm.loadingImport },
                        on: { click: _vm.handleClickContinue },
                      },
                      [_vm._v("Tiếp tục\n        ")]
                    )
                  : _vm._e(),
                _c(
                  "el-button",
                  { attrs: { type: "danger" }, on: { click: _vm.handleClose } },
                  [
                    _c("i", { staticClass: "el-icon-circle-close" }),
                    _vm._v(" Đóng\n        "),
                  ]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "580px",
            title: "Tạo đợt thu",
            visible: _vm.isOpenImportChecker,
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isOpenImportChecker = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Chọn tháng/đợt thu",
                    "label-width": "150px",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 21 } },
                        [
                          _c("el-date-picker", {
                            staticClass: "custom-date-picker",
                            staticStyle: { width: "135px" },
                            attrs: {
                              clearable: true,
                              type: "month",
                              placeholder: "Chọn tháng",
                              "value-format": "M-yyyy",
                              format: "MM-yyyy",
                              "time-arrow-control": false,
                            },
                            on: { change: _vm.handelChangeDate },
                            model: {
                              value: _vm.monthAndYearUpload,
                              callback: function ($$v) {
                                _vm.monthAndYearUpload = $$v
                              },
                              expression: "monthAndYearUpload",
                            },
                          }),
                          _c(
                            "el-select",
                            {
                              staticClass: "input-common",
                              staticStyle: {
                                width: "130px",
                                "margin-left": "10px",
                              },
                              attrs: { placeholder: "Đợt thu", clearable: "" },
                              on: { change: _vm.showStartAndEndDate },
                              model: {
                                value: _vm.turn,
                                callback: function ($$v) {
                                  _vm.turn = $$v
                                },
                                expression: "turn",
                              },
                            },
                            _vm._l(_vm.collectionTurn, function (item) {
                              return _c("el-option", {
                                key: item,
                                attrs: { value: item, label: `Đợt ${item}` },
                              })
                            }),
                            1
                          ),
                          _c(
                            "el-button",
                            {
                              on: { click: _vm.handleOpenInputDescriptionTurn },
                            },
                            [_c("i", { staticClass: "el-icon-circle-plus" })]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.isInputDescriptionTurn
                ? _c(
                    "el-form-item",
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 4 } }, [
                            _c("span", [_vm._v("Mô tả đợt thu")]),
                          ]),
                          _c(
                            "el-col",
                            {
                              staticStyle: { "margin-left": "60px" },
                              attrs: { span: 14 },
                            },
                            [
                              _c("el-input", {
                                staticStyle: {
                                  width: "335px",
                                  "font-family": "Roboto,serif",
                                },
                                attrs: {
                                  autocomplete: "off",
                                  placeholder: "Mời nhập mô tả đợt thu",
                                  type: "textarea",
                                },
                                model: {
                                  value: _vm.form.descriptionTurn,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "descriptionTurn", $$v)
                                  },
                                  expression: "form.descriptionTurn",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: { label: "Khoảng thời gian", "label-width": "140px" },
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "335px", "margin-left": "10px" },
                    attrs: {
                      format: "dd-MM-yyyy",
                      type: "daterange",
                      align: "right",
                      "unlink-panels": "",
                      "range-separator": "-",
                      "start-placeholder": "Ngày bắt đầu",
                      "end-placeholder": "Ngày kết thúc",
                      "picker-options": _vm.pickerOptions,
                    },
                    model: {
                      value: _vm.listDay,
                      callback: function ($$v) {
                        _vm.listDay = $$v
                      },
                      expression: "listDay",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "file-upload-field" },
            [
              _c(
                "el-upload",
                {
                  ref: "upload",
                  attrs: {
                    action: "#",
                    "auto-upload": false,
                    "on-change": _vm.handleUpload,
                    "on-preview": _vm.handlePreview,
                    "on-remove": _vm.handleRemove,
                    "before-remove": _vm.beforeRemove,
                    accept: ".xls,.xlsx",
                    "file-list": _vm.fileList,
                    limit: 1,
                    "close-on-click-modal": false,
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "font-size": "15px" },
                      attrs: { size: "small", type: "primary" },
                    },
                    [
                      _vm._v("Tải file "),
                      _c("i", { staticClass: "el-icon-upload el-icon-right" }),
                    ]
                  ),
                  _c("span", { staticStyle: { "margin-left": "55px" } }, [
                    _vm._v(
                      "Đề nghị tải file Excel theo đúng định dạng của Onekids"
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "custom_button" },
            [
              _vm.showUploadButton
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.loadingImport },
                      on: { click: _vm.handleExcelImport },
                    },
                    [
                      _vm._v("Upload "),
                      _c("i", { staticClass: "el-icon-upload el-icon-right" }),
                    ]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "45px" },
                  attrs: { type: "danger" },
                  on: { click: _vm.handleClose },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-close" }),
                  _vm._v(" Đóng\n      "),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }